import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import { BackNavRow, PageContainer } from "../common/CommonStyles";
import { useTranslation } from "react-i18next";
import {
  AnalyticsContext,
  ViewLegalEvent,
} from "../common/context/AnalyticsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";

export const LegalPage: React.FC = () => {
  const { t } = useTranslation();
  React.useState<Boolean>(false);
  const { logEvent } = React.useContext(AnalyticsContext);

  const items = [
    [t("legal_data_handling"), "/data-handling/"],
    [t("legal_privacy_policy"), "/privacy-policy/"],
    [t("legal_terms_of_use"), "/terms-of-use/"],
    // CC BY 4.0 attributions for the standards data.
    [t("legal_standards_attributions"), "/standards-attributions/"],
  ];

  React.useEffect(() => {
    logEvent(new ViewLegalEvent());
  }, [logEvent]);

  return (
    <PageContainer>
      <BackNavRow label={t("generic_nav_back")}>
        <h2>{t("legal_title")}</h2>
      </BackNavRow>
      <>
        <Row className="justify-content-center mt-4">
          <Col xs={12} lg={8} xl={6}>
            <Container className="my-4">
              <div className="border rounded overflow-hidden">
                {items.map(([text, link], i) => (
                  <a
                    href={link}
                    key={link + "-link"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <Row
                      key={link + "-row"}
                      className={i < items.length - 1 ? "border-bottom" : ""}
                      style={{
                        marginLeft: 0,
                        marginRight: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        borderBottom: undefined,
                        marginInline: "0.5rem",
                      }}
                    >
                      <Col
                        key={text}
                        className="py-2 px-1"
                        style={{
                          flexGrow: 1,
                          borderLeft: "none",
                          borderRight: "none",
                        }}
                      >
                        {text}
                      </Col>
                      <Col
                        xs="auto"
                        className="py-2 px-3"
                        style={{ whiteSpace: "nowrap", borderLeft: "none" }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} />
                      </Col>
                    </Row>
                  </a>
                ))}
              </div>
            </Container>
          </Col>
        </Row>
      </>
    </PageContainer>
  );
};
